import { TPresenceItem } from '@/types/presences';

export const getPreviousPresenceById = (
  givenId: string,
  collection: TPresenceItem[]
): TPresenceItem | null => {
  const index = collection.findIndex(item => item.id === givenId);
  return index <= 0 ? null : collection[index - 1];
};
